import React from 'react';
import { Form, Input, Button, message } from 'antd';
import emailjs from 'emailjs-com'; // Import EmailJS
import './FooterMapSection.css';  // Updated CSS file name

const { TextArea } = Input;

const FooterMapSection = () => {
  return (
    <footer className="footer-section">
      {/* Upper Section with Map and Form */}
      <div className="footer-section-top">
        <div className="footer-map">
          <FooterMap />
        </div>
        <div className="footer-form">
          <MyForm />
        </div>
      </div>
    </footer>
  );
};

// Map Section
const FooterMap = () => (
  <div className="map">
    <iframe
      title="Location"
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1192.961343228902!2d80.24601966996455!3d12.915773657526858!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a525d41156145ef%3A0x84bd8447136324d!2sChosen%20IT%20Academy!5e1!3m2!1sen!2sin!4v1731943562877!5m2!1sen!2sin"
      width="100%"
      height="100%"
      style={{ border: 0 }}
      allowFullScreen
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
    ></iframe>
  </div>
);

// Contact Form Section
const MyForm = () => {
  const [form] = Form.useForm(); // Initialize form instance

  const onFinish = (values) => {
    // The form data to be sent to the email template
    const emailParams = {
      name: values.name,
      email: values.email,
      phone: values.phone,
      message: values.message,
    };

    // Send email via EmailJS
    emailjs.send(
      'service_oit4bk9', // Replace with your EmailJS service ID
                'template_xny0vd6', // Replace with your EmailJS template ID
                emailParams,
                '6xlgr_2EFvcPEjnDG' // Replace with your EmailJS public key
    )
    .then((response) => {
      console.log('SUCCESS!', response.status, response.text);
      message.success('Your message has been sent successfully!');
      
      // Reset the form fields after successful submission
      form.resetFields();
    })
    .catch((err) => {
      console.log('FAILED...', err);
      message.error('There was an error sending your message. Please try again later.');
    });
  };

  return (
    <div className="form-container">
      <h2>Reach Out To Us</h2>
      <Form
        form={form} // Connect form instance
        name="contact-form"
        onFinish={onFinish}
        initialValues={{
          name: '',
          email: '',
          phone: '',
          message: '',
        }}
        layout="vertical"
      >
        {/* Name Input */}
        <Form.Item
          label="Name"
          name="name"
          rules={[{ required: true, message: 'Please enter your name!' }]}
        >
          <Input placeholder="Enter your name" />
        </Form.Item>

        {/* Email Input */}
        <Form.Item
          label="Email"
          name="email"
          rules={[{ required: true, message: 'Please enter your email!' }, { type: 'email', message: 'Please enter a valid email!' }]}
        >
          <Input placeholder="Enter your email" />
        </Form.Item>

        {/* Phone Number Input */}
        <Form.Item
          label="Phone Number"
          name="phone"
          rules={[{ required: true, message: 'Please enter your phone number!' }, { pattern: /^[0-9]{10}$/, message: 'Please enter a valid phone number!' }]}
        >
          <Input placeholder="Enter your phone number" />
        </Form.Item>

        {/* Message Input */}
        <Form.Item
          label="Message"
          name="message"
          rules={[{ required: true, message: 'Please enter your message!' }]}
        >
          <TextArea rows={4} placeholder="Enter your message" />
        </Form.Item>

        {/* Submit Button */}
        <Form.Item>
          <Button type="primary" htmlType="submit" block >
            Submit
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default FooterMapSection;
